import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play, Pause, SpeakerSimpleHigh, SpeakerSimpleSlash } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { mediaUrl } from "../../lib/api";
import { Reveal, Kicker } from "./Reveal";

export const VideoShowcase = ({ content }) => {
  const { t, lang, pick } = useLang();
  const video = content?.video;
  const ref = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(true);

  if (!video?.url) return null;
  const title = video[`title_${lang}`] || "";

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPlaying(true); } else { v.pause(); setPlaying(false); }
  };
  const toggleMute = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <section id="video" className="relative bg-taxi py-24 md:py-36 border-y border-black/10" data-testid="video-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <Reveal><Kicker>MY TAXI · Live</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-black text-5xl md:text-7xl uppercase whitespace-pre-line leading-[0.88]">{title}</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-black/70 text-base md:text-lg leading-relaxed max-w-md">{pick(video, "subtitle")}</p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="relative border border-white/10 bg-black overflow-hidden group">
                <video
                  ref={ref}
                  src={mediaUrl(video.url)}
                  poster={mediaUrl(content?.hero?.image)}
                  className="w-full h-auto max-h-[75vh] min-h-[280px] object-contain mx-auto bg-black"
                  autoPlay muted loop playsInline preload="auto"
                  data-testid="showcase-video"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10 pointer-events-none" />
                <div className="absolute bottom-4 left-4 flex items-center gap-3">
                  <button onClick={toggle} className="h-11 w-11 bg-taxi text-black flex items-center justify-center hover:bg-white transition-colors" data-testid="video-play-toggle" aria-label="play-pause">
                    {playing ? <Pause size={20} weight="fill" /> : <Play size={20} weight="fill" />}
                  </button>
                  <button onClick={toggleMute} className="h-11 w-11 bg-black/70 backdrop-blur text-white border border-white/20 flex items-center justify-center hover:border-taxi hover:text-taxi transition-colors" data-testid="video-mute-toggle" aria-label="mute">
                    {muted ? <SpeakerSimpleSlash size={20} weight="fill" /> : <SpeakerSimpleHigh size={20} weight="fill" />}
                  </button>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
